export const environment = {
    production: true,
    apiUrl: 'https://api.staging.pebra.ch/api/v1',
    websiteUrl: 'https://website.staging.pebra.ch',
    fbclientId: '875937464558129',
    googleclientId: '946817598286-261phkf1mjjcg54f9gm98i9o6neci4l3.apps.googleusercontent.com'
  };

